import * as mutations from '../../mutation-types'

export const processPermitType = (store, permitType) => {
    store.commit(mutations.ADD_OR_UPDATE_PERMIT_TYPE, permitType)
}

export const fetchPermitTypes = (store) => {
    return axios.get(`/api/permit-types`)
        .then(res => {
            _.each(res.data.data, item => processPermitType(store, item))
            return res
        })
}

export const createPermitType = (store, item) => {
    return axios.post(`/api/permit-types`, item)
        .then(res => {
            processPermitType(store, res.data.data)
            return res
        })
}

export const updatePermitType = (store, item) => {
    return axios.patch(`/api/permit-types/${item.id}`, item)
        .then(res => {
            processPermitType(store, res.data.data)
            return res
        })
}

export const createOrUpdatePermitType = (store, item) => {
    return item.id
        ? updatePermitType(store, item)
        : createPermitType(store, item)
}

export const removePermitType = (store, item) => {
    return axios.delete(`/api/permit-types/${item.id}`)
        .then(res => {
            store.commit(mutations.REMOVE_PERMIT_TYPE, item)
            return res
        })
}